import { Badge } from "react-bootstrap"
import { ReloadOutline } from "react-ionicons"

const SourceState = ({ state, size = 12 }) => {
    switch (state) {
        case 0:
            return <Badge bg='dark'>Detenido</Badge>
        case 1:
            return <Badge bg='success'>En linea</Badge>
        case 2:
            return <Badge bg='warning'>Backup</Badge>
        case 3:
            return <Badge bg='primary'>Iniciando <ReloadOutline color="fff" width={`${size}px`} height={`${size}px`} rotate /></Badge>
        case 4:
            return <Badge bg='danger'>Fallido</Badge>
        case 5:
            return <Badge bg='light'>Esperando</Badge>
        default:
            return <Badge bg='secondary'>Desactivado</Badge>
    }
}

export default SourceState;